






























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class TableFooter extends Vue {
  @Prop({ required: true }) itemsLength!: number;
  @Prop({ default: 10 }) rowsPerPage!: number;
  @Prop({
    default: () => [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "15", value: 15 },
      { text: "All", value: -1 }
    ]
  })
  rowsPerPageItems!: { text: string; value: number }[];
  @Prop({ required: true }) currentPage!: number;

  private localRowsPerPage = this.rowsPerPage;

  @Watch("localRowsPerPage")
  onLocalRowsPerPageChange(val: number) {
    this.$emit("update:rowsPerPage", val);
    this.$emit("update:currentPage", 1);
  }
}
